import { gql } from '@apollo/client';

const MOVE_HELP_ARTICLE = gql`mutation moveHelpArticle($input: MoveHelpArticleInput!) {
  helpContext {
    moveHelpArticle(input: $input) {
			success
			message
			article {
        articleId: id
        topicId
        index
        title
        description
        content
        related
        tags
			}
    }
  }
}`;

export default MOVE_HELP_ARTICLE;
